import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=4072909b"
import script from "./ProductListItem.vue?vue&type=script&lang=ts"
export * from "./ProductListItem.vue?vue&type=script&lang=ts"
import style0 from "./ProductListItem.vue?vue&type=style&index=0&id=4072909b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports